module.exports = __webpack_public_path__ + "img/142.fdb2cd2d.jpg";